// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import './Nav.css';

// function Nav() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     setIsOpen(false);
//     window.scrollTo(0, 0);
//   }, [location.pathname]);

//   useEffect(() => {
//     const handleScroll = () => setIsScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

// //   const navLinks = [
// //     { path: '/home', label: 'Home' },
// //     { path: '/logout', label: 'Logout' },
// //   ];
// // Update the navLinks array in your Nav component:
// const navLinks = [
//   { path: '/', label: 'Dashboard' },
//   { path: '/', label: 'Blogs' },
//   { path: '/', label: 'Offers' }
// ];
//   return (
//     <nav className={`nav ${isScrolled ? 'nav-scrolled' : ''}`}>
//       <div className="logo-container">
//         <Link to="/" className="logo">
//           TOP<span>RANO</span>
//         </Link>
//         <h5 className="hotels-lounge">hotels & lounge Admin </h5>
//       </div>
//       <ul className={`menu ${isOpen ? 'menu-open' : 'menu-closed'} lg:menu-desktop`}>
//         {navLinks.map((link, index) => (
//           <li key={index} className="menu-item">
//             {index > 0 && <span className="menu-divider lg:menu-divider-visible"></span>}
//             <Link
//               to={link.path}
//               className={`menu-link ${location.pathname === link.path ? 'active' : ''}`}
//             >
//               {link.label}
//             </Link>
//           </li>
//         ))}
//       </ul>
//       <div className="mobile-menu-toggle lg:hidden">
//         <button
//           onClick={() => setIsOpen(!isOpen)}
//           aria-label={isOpen ? 'Close menu' : 'Open menu'}
//         >
//           <i className={`ri-menu-line menu-icon ${isOpen ? 'hidden' : 'block'}`}></i>
//           <i className={`ri-close-line menu-icon ${isOpen ? 'block' : 'hidden'}`}></i>
//         </button>
//       </div>
//     </nav>
//   );
// }

// export default Nav;



// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import './Nav.css';

// function Nav() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     setIsOpen(false);
//     window.scrollTo(0, 0);
//   }, [location.pathname]);

//   useEffect(() => {
//     const handleScroll = () => setIsScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navLinks = [
//     { path: '/home', label: 'Dashboard' },
//     { path: '/home#blogs', label: 'Blogs' },
//     { path: '/home#offers', label: 'Offers' },
//     { path: '/login', label: 'Logout' }
//   ];

//   const handleLinkClick = (path, tab) => {
//     if (path === '/home' && tab) {
//       setTimeout(() => {
//         document.getElementById(tab)?.scrollIntoView({ behavior: 'smooth' });
//       }, 100);
//     }
//   };

//   return (
//     <nav className={`nav ${isScrolled ? 'nav-scrolled' : ''}`}>
//       <div className="logo-container">
//         <Link to="/home" className="logo">
//           TOP<span>RANO</span>
//         </Link>
//         <h5 className="hotels-lounge">Hotels & Lounge Admin</h5>
//       </div>
//       <ul className={`menu ${isOpen ? 'menu-open' : 'menu-closed'}`}>
//         {navLinks.map((link, index) => (
//           <li key={index} className="menu-item">
//             {index > 0 && <span className="menu-divider"></span>}
//             <Link
//               to={link.path}
//               className={`menu-link ${location.pathname === link.path ? 'active' : ''}`}
//               onClick={() => handleLinkClick(link.path, link.label.toLowerCase())}
//             >
//               {link.label}
//             </Link>
//           </li>
//         ))}
//       </ul>
//       <div className="mobile-menu-toggle">
//         <button
//           onClick={() => setIsOpen(!isOpen)}
//           aria-label={isOpen ? 'Close menu' : 'Open menu'}
//           className="toggle-button"
//         >
//           <i className={`ri-menu-line menu-icon ${isOpen ? 'hidden' : 'block'}`}></i>
//           <i className={`ri-close-line menu-icon ${isOpen ? 'block' : 'hidden'}`}></i>
//         </button>
//       </div>
//     </nav>
//   );
// }

// export default Nav;



import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Nav.css';

function Nav({ setActiveTab }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsOpen(false);
    navigate('/login');
  };

  const navLinks = [
    { path: '/home', label: 'Dashboard', tab: 'dashboard' },
    { path: 'https://topranohotelandlounge.com', label: 'Go to Webite', tab: 'Go to Webite' },
    { path: '/login', label: 'Logout', action: handleLogout }
  ];

  const handleLinkClick = (path, tab, action) => {
    if (action) {
      action();
    } else if (path === '/home' && tab && setActiveTab) {
      setActiveTab(tab);
      setTimeout(() => {
        document.getElementById(tab)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
    setIsOpen(false);
  };

  return (
    <nav className={`nav ${isScrolled ? 'nav-scrolled' : ''}`}>
      <div className="logo-container">
        <Link to="/home" className="logo">
          TOP<span>RANO</span>
        </Link>
        <h5 className="hotels-lounge">Hotels & Lounge Admin</h5>
      </div>
      <ul className={`menu ${isOpen ? 'menu-open' : 'menu-closed'}`}>
        {navLinks.map((link, index) => (
          <li key={index} className="menu-item">
            {index > 0 && <span className="menu-divider"></span>}
            <Link
              to={link.path}
              className={`menu-link ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => handleLinkClick(link.path, link.tab, link.action)}
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
      <div className="mobile-menu-toggle">
        <button
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          className="toggle-button"
        >
          <i className={`ri-menu-line menu-icon ${isOpen ? 'hidden' : 'block'}`}></i>
          <i className={`ri-close-line menu-icon ${isOpen ? 'block' : 'hidden'}`}></i>
        </button>
      </div>
    </nav>
  );
}

export default Nav;